<template>
  <div class="main">
    <div class="header">创建订单
      <div class="regx-wrap">
        <!-- <textarea placeholder="黏贴联系人信息，逗号分割" class="regx-text el-textarea__inner" style="height: 30px; min-height: 30px; max-height: 177px; overflow-y: hidden;"></textarea> -->
        <el-input class="regx-text" v-model="form.addressContacts" type="textarea" placeholder="黏贴联系人信息，自动识别" autosize @change="handleIntell"></el-input>
      </div>
    </div>

    <el-form class="form" ref="form" :rules="rules" :model="form" label-width="150px">
      <el-form-item label="店铺" class="small" prop="shopName" v-if="deptName=='易跑健康-电商部'||deptName=='亿健-电商部'">
        <el-select
          v-model="form.shopName"
          placeholder="店铺"
          size="large"
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="item in shopNamelist"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="店铺" class="small" prop="shopName" v-if="deptName!='易跑健康-电商部'&&deptName!='亿健-电商部'">
        <el-input v-model="form.shopName" placeholder="店铺"></el-input>
      </el-form-item>

      <el-form-item label="购买时间" class="small" prop="buyDate" v-if="deptName=='亿健-电商部'">
        <el-date-picker
        v-model="form.buyDate"
          type="date"
          value-format="yyyy-MM-dd"
          editable="false"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="订单号" class="small" prop="expressNumber">
        <el-input v-model="form.expressNumber" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="联络人姓名" class="small" prop="contacts">
        <el-input v-model="form.contacts" placeholder="请输入联络人姓名"></el-input>
      </el-form-item>
      <el-form-item label="联络人手机号" class="small" prop="phoneNumber">
        <el-input v-model="form.phoneNumber" placeholder="请输入联络人手机号"></el-input>
      </el-form-item>
      <el-form-item label="地址" class="small" prop="provinces">
        <el-cascader size="large" :options="options" v-model="form.provinces" :props="props" @change="handleChange" placeholder="请选择省市区"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="detailedAddress">
        <el-input v-model="form.detailedAddress" placeholder="请输入详细地址"></el-input>
      </el-form-item>
      <el-form-item label="预约类型" prop="taskType">
        <el-radio-group v-model="form.taskType">
          <el-radio :label="2">安装</el-radio>
          <el-radio :label="1">维修</el-radio>
          <el-radio :label="3">退换</el-radio>
          <el-radio :label="4">自费</el-radio>
        </el-radio-group>
      </el-form-item>



      <el-form-item label="产品名称" prop="equipType">
        <el-input v-model="form.equipType"></el-input>
      </el-form-item>



      <el-form-item label="产品型号" prop="equipModel" v-if="deptName!='亿健-电商部'">
        <el-input v-model="form.equipModel"></el-input>
      </el-form-item>
      <el-form-item label="产品型号" prop="equipModel" v-if="deptName=='亿健-电商部'">
        <el-select
          v-model="form.equipModel"
          placeholder="产品型号"
          size="large"
          filterable
          style="width: 100%"
        >
          <el-option
            v-for="item in yj"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>



      <el-form-item label="机身编码" prop="machineCode" v-if="deptName=='亿健-电商部'">
        <el-input v-model="form.machineCode"></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="taskDescription">
        <el-input v-model="form.taskDescription" type="textarea" autosize></el-input>
      </el-form-item>
      <!-- <el-form-item label="备注图片/视频">
        <el-upload
            action
            :multiple="false"
            v-model="form.file"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
            accept="image/png, image/jpg, image/jpeg,video/mp4"
            class="avatar-uploader"
        >
          <img v-if="form.url" :src="form.url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item> -->
    </el-form>
    <div class="footer">
      <el-button :disabled="btnDisabled" class="submit" type="primary" @click="onSubmit('form')">立即下单</el-button>
    </div>
  </div>
</template>

<script>
import AddressParse from 'address-parse'
import { regionData } from "element-china-area-data";//引入

import { number } from 'echarts'

import yj from '../../utils/yj.json'
import axios from 'axios';
export default {
  data(){
    return {
      form: {
        machineCode:'',
        buyDate:'',
        contacts: '',
        phoneNumber: '',
        detailedAddress: '',
        addressContacts: '',
        taskType: 2,
        equipType: '',
        equipModel: '',
        taskDescription: '',
        expressNumber:'',
        province: '',
        city: '',
        region: '',
        provinces: [], //省市区绑定数组
      },
      cform:{

      },
      btnDisabled:false,
      props: {
        value: 'label'
      },
      options: regionData,//选择格式
      rules: {
        equipModel:[
          { required: JSON.parse(localStorage.getItem('userinfo')).deptName=="亿健-电商部", message: '产品型号' }
        ],
        equipType:[
          { required: JSON.parse(localStorage.getItem('userinfo')).deptName=="亿健-电商部", message: '产品名称' }
        ],
        buyDate:[
          { required: JSON.parse(localStorage.getItem('userinfo')).deptName=="亿健-电商部", message: '购买时间' }
        ],
        machineCode:[
          { required: JSON.parse(localStorage.getItem('userinfo')).deptName=="亿健-电商部", message: '机身编号' }
        ],
        shopName: [
          { required: true, message: '店铺' }
        ],
        expressNumber:[
          { required: true, message: '订单号' }
        ],
        contacts: [
          { required: true, message: '请输入联络人姓名' }
        ],
        provinces: [
          { required: true, message: '请选择省市区' }
        ],
        phoneNumber: [
          { required: true, message: '请输入联络人手机号' }
        ],
        detailedAddress: [
          { required: true, message: '请输入详细地址' }
        ],
        taskType: [
          { required: true, message: '请选择预约类型' }
        ],
      },
      shopNamelist:[],
      // shopNamelist:[
      //   {
      //     value:"抖音-抖音易跑旗舰店",
      //   },
      //   {
      //     value:"非购买机型",
      //   },
      //   {
      //     value:"京东-易跑京东旗舰店",
      //   },
      //   {
      //     value:"京东-易跑运动户外旗舰店",
      //   },
      //   {
      //     value:"京东-蓝鹰官方旗舰店",
      //   },
      //   {
      //     value:"京东-蓝鹰京东自营",
      //   },
      //   {
      //     value:"京东-易跑官方旗舰店",
      //   },
      //   {
      //     value:"京东-易跑京东自营旗舰店",
      //   },
      //   {
      //     value:"京东-易跑领美专卖店",
      //   },
      //   {
      //     value:"拼多多-易跑运动旗舰店",
      //   },
      //   {
      //     value:"拼多多-易跑旗舰店",
      //   },
      //   {
      //     value:"天猫-蓝鹰旗舰店",
      //   },
      //   {
      //     value:"天猫-速立达旗舰店",
      //   },
      //   {
      //     value:"天猫-天猫越俊专卖店",
      //   },
      //   {
      //     value:"天猫-易跑旗舰店",
      //   },
      //   {
      //     value:"天猫-天猫越俊专卖店",
      //   },
      //   {
      //     value:"经销亿朗店",
      //   },
      //   {
      //     value:"唯品会",
      //   },
      //   {
      //     value:"线下店",
      //   },
      //   {
      //     value:"华为BOP",
      //   }
      // ],
      deptName:JSON.parse(localStorage.getItem('userinfo')).deptName,
      yj
    }
  },
  created(){
    
    if(this.deptName=="易跑健康-电商部"){
      this.shopNamelist=[
        {
          value:"抖音-抖音易跑旗舰店",
        },
        {
          value:"非购买机型",
        },
        {
          value:"京东-易跑京东旗舰店",
        },
        {
          value:"京东-易跑运动户外旗舰店",
        },
        {
          value:"京东-蓝鹰官方旗舰店",
        },
        {
          value:"京东-蓝鹰京东自营",
        },
        {
          value:"京东-易跑官方旗舰店",
        },
        {
          value:"京东-易跑京东自营旗舰店",
        },
        {
          value:"京东-易跑领美专卖店",
        },
        {
          value:"拼多多-易跑运动旗舰店",
        },
        {
          value:"拼多多-易跑旗舰店",
        },
        {
          value:"天猫-蓝鹰旗舰店",
        },
        {
          value:"天猫-速立达旗舰店",
        },
        {
          value:"天猫-天猫越俊专卖店",
        },
        {
          value:"天猫-易跑旗舰店",
        },
        {
          value:"天猫-天猫越俊专卖店",
        },
        {
          value:"经销亿朗店",
        },
        {
          value:"唯品会",
        },
        {
          value:"线下店",
        },
        {
          value:"华为BOP",
        }
      ]
    }
    if(this.deptName=="亿健-电商部"){
      this.shopNamelist=[
        {
          value:"北京普天太力通信科技有限公司",
        },
        {
          value:"产品/品牌样机及赠品店铺(不归还)",
        },
        {
          value:"产品/品牌样机及赠品店铺(需归还)",
        },
        {
          value:"抖店-亿健官方旗舰店",
        },
        {
          value:"杭州骏驰电子商务有限公司",
        },
        {
          value:"京东-AD健身训练旗舰店",
        },
        {
          value:"京东-亿健嘉俊店",
        },
        {
          value:"京东-亿健京东旗舰店",
        },
        {
          value:"京东-亿健京东自营专区",
        },
        {
          value:"京东-亿健隽逸专卖店1",
        },
        {
          value:"京东-亿健体育用品旗舰店",
        },
        {
          value:"京东-亿健运动专卖店1",
        },
        {
          value:"京东-亿健自营旗舰店",
        },
        {
          value:"拼多多-亿健官方旗舰店",
        },
        {
          value:"天猫-ad旗舰店1",
        },
        {
          value:"天猫-亿健尼欧专卖店1",
        },
        {
          value:"天猫-亿健帅隽专卖店1",
        },
        {
          value:"天猫-亿健运动旗舰店1",
        },
        {
          value:"线下-华为商城(泊康)",
        },
        {
          value:"线下-散户",
        },
        {
          value:"亿健官方旗舰店-华为商城(神码)",
        },
        {
          value:"自有/其他",
        },
        {
          value:"天猫-亿健爱康专卖店",
        },
        {
          value:"京东-熣灿健身用品专营店(一盘货)",
        },
        {
          value:"京东-熣灿运动专营店(一盘货)",
        },
        {
          value:"京东-亿健专卖店(一盘货)",
        },
        {
          value:"拼多多-熣灿运动专营店",
        },
        {
          value:"唯品会-亿健运动旗舰店",
        },
        {
          value:"苏宁-熣灿运动旗舰店",
        },
        {
          value:"苏宁-亿健爱康专卖店",
        },
        {
          value:"天猫-亿健云豹专卖店",
        },
        {
          value:"京东-亿健必腾专卖店",
        },
        {
          value:"拼多多-亿健必腾专卖店",
        },
        {
          value:"苏宁-亿健云豹专卖店",
        },
        {
          value:"AD-态级专卖店",
        },
        {
          value:"京东-亿健东鸣专卖店",
        },
        {
          value:"拼多多-亿健迎康专卖店",
        },
        {
          value:"天猫-亿健宝德专卖店",
        },
        {
          value:"京东-亿健傲冠专卖店",
        },
        {
          value:"苏宁-亿健运动旗舰店(经销商)",
        },
        {
          value:"拼多多-健跑运动户外个人店",
        },
        {
          value:"拼多多-亿健源柏专卖店",
        },
        {
          value:"抖店-亿健健森商盟专卖店",
        },
        {
          value:"天猫-亿健公司直销(一盘货)",
        },
        {
          value:"天猫-淘宝亿健生命在于运动店",
        },
        {
          value:"京东-亿健争先渡专卖店",
        },
        {
          value:"天猫-亿健智宝科专卖店",
        },
        {
          value:"健森抖音店",
        },
      ]
    }
    // this.options.forEach(function(active){
    //   if(active.label=="山东省"){
    //     active.children.forEach(function(a,i){
    //       if(a.label=="潍坊市"){
    //         a.children.push({
    //           children: null,
    //           label: "高新区",
    //           value:"370791"
    //         })
    //         console.log(a.children);

    //       }
    //     })
    //   }
    // })
    
  },
  methods: {
    handleChange(e) {
      this.form.province = e[0]
      this.form.city = e[1]
      this.form.region = e[2]
      // console.log(this.form.provinces)
    },
    getMoney() {
      this.$axios.get('/recharge/management/getAmountInfo').then(res=> {
          this.cform = res.data
      })
    },
    handleAvatarSuccess(res, file, fileList) {
      this.$message({
        center: true,
        message: '上传成功',
        type: 'success',
      })
    },
    beforeAvatarUpload(file) {
      // ++
      // console.log(file)
      this.form.file = file
      this.imagePreview(this.form.file, 1)
      return false
    },
    uploadError() {
      // ?不需要，上传失败操作
    },
    imagePreview(file, v) {
      var self = this
      //定义一个文件阅读器
      var reader = new FileReader()
      //文件装载后将其显示在图片预览里
      reader.onload = function (e) {
        //将bade64位图片保存至数组里供上面图片显示
        if (v == 1) {
          self.form.url = e.target.result
          // console.log(self.form.url)
        } else {
          self.vedioUrl.url = e.target.result
        }
      }
      reader.readAsDataURL(file)
    },
    handleIntell() {

      if(this.form.addressContacts==''){
        return
      }
      
      const [result] = AddressParse.parse(this.form.addressContacts);//intell input框 data中定义
      if (result.province =='北京' || result.province== '上海' || result.province== '天津' || result.province== '重庆') {
        this.form.province = result.province+'市'
      }else {
        this.form.province = result.province
      }
      const regex1 = new RegExp("区", "g");
      const regex2 = new RegExp("办事处", "g");
      if (result.area.indexOf("街道办事处") != -1) {
        if (result.area.indexOf("区") > 1) {
          result.area = result.area.replace(regex1, "");
        }
        result.area = result.area.replace(regex2, "");
      }
      if (result.province == "浙江省" && result.area == "") {
        if (result.details.indexOf("临平区") != -1) {
          result.area = "临平区";
        }
        if (result.details.indexOf("钱塘区") != -1) {
          result.area = "钱塘区";
        }
      }


      if (result.province == "山东省" && result.city == "潍坊市" && result.area=="高新区") {
        result.area="奎文区"
      }

      if(result.city==""||result.province==""||result.area==""){
        axios({
          method:"post",
          url:"https://wangzc.wang/smAddress",
          data:{
            address:this.form.addressContacts,
          }
        }).then(res=>{
          console.log(res);
          let detail=res.data.province+res.data.city+res.data.county+res.data.address
          this.form.detailedAddress  = detail
          this.form.contacts = result.name||res.data.name
          this.form.phoneNumber = result.mobile||res.data.phone
          this.form.province = this.form.province||res.data.province
          if (res.data.province =='北京市' || res.data.province== '上海市' || res.data.province== '天津市' || res.data.province== '重庆市') {
            this.form.city = '市辖区'
          }else {
            this.form.city = res.data.city
          }
          this.form.region = res.data.county
          console.log(this.form.province);
          this.form.provinces = [this.form.province,this.form.city,res.data.county]

        })

      return
    }

      let detail =  result.province + result.city +result.area + result.details
      this.form.contacts = result.name
      this.form.detailedAddress  = detail
      this.form.phoneNumber = result.mobile


      

    if (result.province =='北京' || result.province== '上海' || result.province== '天津' || result.province== '重庆') {
      this.form.city = '市辖区'
    }else {
      this.form.city = result.city
    }

    this.form.region = result.area
    this.form.provinces = [this.form.province,this.form.city,result.area]

    

   

    

		// const [result] = AddressParse.parse(this.form.addressContacts);//intell input框 data中定义
    // // console.log(result)

    // let detail =  result.province + result.city +result.area + result.details
    // this.form.contacts = result.name
    // this.form.detailedAddress  = detail
    // this.form.phoneNumber = result.mobile


    //   if (result.province =='北京' || result.province== '上海' || result.province== '天津' || result.province== '重庆') {
    //     this.form.province = result.province+'市'
    //   }else {
    //     this.form.province = result.province
    //   }

    // if (result.province =='北京' || result.province== '上海' || result.province== '天津' || result.province== '重庆') {
    //   this.form.city = '市辖区'
    // }else {
    //   this.form.city = result.city
    // }

    // this.form.region = result.area
    // this.form.provinces = [this.form.province,this.form.city,result.area]
		// this.formData.realname = result.name
		// this.formData.mobile = result.mobile
		// this.formData.address_details = result.details
		// //赋值给地址选择框
		// this.$refs.cityPicker.intelligenceSet(result.province, result.city, result.area)
	},
    // contactsInput(t){
    //   // value=value.replace(/(，+)/g,',').replace(/(^(,*))|((,*)$)/gi,"").replace(/(,+)/g, "\n")
    //   // this.form.addressContacts=value
    //   // value.split('\n').forEach(item=>{
    //   //   if(number(item)){}
    //   // })
    //   let e = this
    //     , a = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
    //   let r = t || ""
    //     , s = r.split(/[,，\n]/).map((function(t) {
    //       return t.trim()
    //   }
    //   ))
    //     , o = s.filter((function(t) {
    //       return !!t
    //   }
    //   ));
    //   this.addressContacts = o.join("\n");
    //   let i = false
    //     , n = false;
    //       o.forEach((function(t) {
    //           !n && a.test(t) ? (e.form.phoneNumber = t,
    //           n = !0) : !i && t.length >= 2 && t.length <= 7 ? (i = !0,
    //           e.form.contacts = t) : t.length > 8 && (e.form.detailedAddress = t)
    //         }
    //       ))
    // },
    onSubmit(formData){
      this.btnDisabled = true
      console.log(this.form);
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.$axios.post('/workOrder/addOrUpdate',this.form).then(res=>{
            if (res.code == 0) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              delete this.form.provinces;
              this.form.addressContacts=""
              this.$refs.form.resetFields();
              this.btnDisabled = false
              this.$router.push('/myorder')
            }else {
              this.btnDisabled = false
            }

          })
        }else  {
          this.btnDisabled = false
        }
      });

    }
  }
}
</script>

<style lang="scss" scoped>
.el-date-editor{
  width: 100%;
}
.avatar-uploader {
    width: 150px;
    height: 150px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
}
.main{
  margin: 40px auto;
  width: 1080px;
  background-color: #fff;
  padding: 22px;
  .header{
    padding-bottom: 23px;
    border-bottom: 1px solid #eee;
    font-size: 20px;
    color: #222;
    line-height: 1;
    position: relative;
    .regx-wrap{
      position: absolute;
      z-index: 5;
      right: 0;
      top: 82px;
      width: 350px;
      font-size: 16px;
      padding: 15px 0;
      .regx-text{
        /deep/ textarea{
          resize: none;
          border: 0;
        }
      }
    }
  }
  .form{
    margin-top: 38px;
  }
  .footer{
    text-align: center;
    .submit{
      width: 190px;
      height: 60px;
    }
  }
}
.el-form-item{
  &.small{
    /deep/ {
      .el-form-item__content{
        width: 460px;
      }
    }
  }
  /deep/ {
    .el-form-item__label,
    .el-form-item__content{
      line-height: 60px;
    }
    .el-cascader {
      width: 100%;
    }
    .el-input__inner{
      height: 60px;
      line-height: 60px;
    }
    .el-form-item__label{
      font-size: 16px;
      color: #798796;
    }
    .el-input{
      font-size: 16px;
    }
    .el-textarea__inner{
      min-height: 100px !important;
    }
  }
}
</style>
